import { render, staticRenderFns } from "./PostAnalytics.vue?vue&type=template&id=1889cff6&"
import script from "./PostAnalytics.vue?vue&type=script&lang=ts&"
export * from "./PostAnalytics.vue?vue&type=script&lang=ts&"
import style0 from "./PostAnalytics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports